import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientFamilyHistoryForm() {
    return (
        <PatientFormTemplate formTitle="Your Family" />
    );
}